import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../common.service';

@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss']
})
export class SuccessPageComponent implements OnInit {


	public email_id = CommonService.email_id;
	public policy_id = CommonService.policy_id;
	
    constructor(private commonService: CommonService) { }

    ngOnInit() {
      this.commonService.changeHeaderLeftIcon("../../../assets/icons/menu.svg")
          CommonService.filtered_coverage = CommonService.coverage;

        this.commonService.changeHeader('')
  }
  
}
